export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-05A.656f1765.png";